import { getColor, getBackgroundColor } from '../../colors/colors.alias';
import { getBorderRadius } from '../../borders/borders.alias';
import getIcons from '../../icons/icons.alias';
import { constants as Icon } from '../Icon';
import { constants as Paragraph } from '../Paragraph';
import { VARIANT_DEFAULT, VARIANT_ERROR, VARIANT_INFORMATIVE, VARIANT_SUCCESS, VARIANT_WARNING, ELEMENT_CONTAINER, ELEMENT_ICON, ELEMENT_TEXT, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'InlineMessage',
    variants: {
        VARIANT_DEFAULT,
        VARIANT_ERROR,
        VARIANT_INFORMATIVE,
        VARIANT_SUCCESS,
        VARIANT_WARNING,
    },
    elements: {
        ELEMENT_CONTAINER,
        ELEMENT_ICON,
        ELEMENT_TEXT,
    },
});
export default function getInlineMessage(transformer, config) {
    const backgroundColor = getBackgroundColor(transformer, config);
    const color = getColor(transformer, config);
    const borderRadius = getBorderRadius(transformer, config);
    const icons = getIcons();
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_CONTAINER]: {
                styles: {
                    borderRadius: borderRadius.containerWithBackgroundColor.value,
                },
                variants: {
                    [VARIANT_ERROR]: {
                        styles: {
                            backgroundColor: backgroundColor.feedback.negative.contentContainer.value,
                        },
                    },
                    [VARIANT_WARNING]: {
                        styles: {
                            backgroundColor: backgroundColor.feedback.warning.contentContainer.value,
                        },
                    },
                    [VARIANT_INFORMATIVE]: {
                        styles: {
                            backgroundColor: backgroundColor.feedback.informative.contentContainer.value,
                        },
                    },
                    [VARIANT_SUCCESS]: {
                        styles: {
                            backgroundColor: backgroundColor.feedback.positive.contentContainer.value,
                        },
                    },
                },
            },
            [ELEMENT_ICON]: {
                variants: {
                    [VARIANT_ERROR]: {
                        styles: {
                            color: color.feedback.negative.icon.value,
                        },
                        components: {
                            [Icon.NAME]: {
                                variant: Icon.variants.VARIANT_MEDIUM,
                                name: icons.feedback.negative.value,
                            },
                        },
                    },
                    [VARIANT_WARNING]: {
                        styles: {
                            color: color.feedback.warning.icon.value,
                        },
                        components: {
                            [Icon.NAME]: {
                                variant: Icon.variants.VARIANT_MEDIUM,
                                name: icons.feedback.warning.value,
                            },
                        },
                    },
                    [VARIANT_INFORMATIVE]: {
                        styles: {
                            color: color.feedback.informative.icon.value,
                        },
                        components: {
                            [Icon.NAME]: {
                                variant: Icon.variants.VARIANT_MEDIUM,
                                name: icons.feedback.informative.value,
                            },
                        },
                    },
                    [VARIANT_SUCCESS]: {
                        styles: {
                            color: color.feedback.positive.icon.value,
                        },
                        components: {
                            [Icon.NAME]: {
                                variant: Icon.variants.VARIANT_MEDIUM,
                                name: icons.feedback.positive.value,
                            },
                        },
                    },
                },
            },
            [ELEMENT_TEXT]: {
                components: {
                    [Paragraph.NAME]: {
                        variant: Paragraph.variants.VARIANT_MEDIUM,
                    },
                },
            },
        },
    });
}
